export const TRAINING_DASHBOARD_LINK_IDENTIFIER = 'training_dashboard';
